import React from 'react';
import './ArithmeticQuizQuestion.css';

function QuizQuestion({ question, handleAnswer }) {
  return (
    <div className="question-container">
      <h2>{question.question}</h2>
      <div className="answers-container">
        {question.answers.map((answer, index) => (
          <button key={index} onClick={() => handleAnswer(answer)}>
            {answer}
          </button>
        ))}
      </div>
    </div>
  );
}

export default QuizQuestion;
